import React, {useState} from "react";
import { useNavigate } from 'react-router-dom';

const UploadPhotoCard = ({picture}) => {
    const navigate = useNavigate();
    
    const handleClick = () => {
        // Build a new jewellery card with items and push to grid
        navigate('/upload-photo');
    }

  
    return ( 
        // TODO: Put all the CSS in App.css
        <div 
            className="grid-item" 
            align="center"
            style={{border: `1px solid white}`}}
            onClick={handleClick}
            >
        <div align="center">
        <img
            src={picture} 
            width="250" 
            height="250"
            /></div>
        <p align="center">Upload Photo</p>
        </div>
);
};

export default UploadPhotoCard;
